import React from "react";
import { Helmet } from "react-helmet";
// import classes from "./EditInvoices.module.scss";

const EditInvoices = () => {
  return (
    <>
      <Helmet>
        <title>Edit Invoices | DDD Invoices</title>
      </Helmet>
      <div className="w-100 h-100">
        <iframe
          src="@invt?header=false"
          frameBorder="0"
          title="edit-invoices-layout"
          style={{ width: "100%", height: "100%" }}
        ></iframe>
      </div>
    </>
  );
};

export default EditInvoices;
